// Mock dataset modeled after publicly disclosed metrics (NIRF / NAAC / AICTE-style indicators).
// Numbers are illustrative for prototype purposes only.

export const colleges = [
  {
    id: "psg-coimbatore",
    name: "PSG College of Technology",
    short: "PSG Tech",
    city: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private — Autonomous",
    established: 1951,
    students: 8400,
    faculty: 412,
    facultyRatio: "1:20",
    accreditation: ["NAAC A++", "NBA"],
    cost: 680000,
    medianSalary: 1080000,
    placementRate: 84,
    higherStudies: 19,
    transparency: 79,
    outcomeScore: 81,
    roiRating: "AAA",
    research: 71,
    diversity: 74,
    sources: ["NIRF 2024", "AICTE Disclosure 2024"],
    advertised: { highest: 7800000, average: 1240000, placementShown: 92 },
    filed: { median: 1080000, average: 980000, placementReported: 84, higherStudiesReported: 19 },
  },
  {
    id: "amrita-coimbatore",
    name: "Amrita School of Engineering, Coimbatore",
    short: "Amrita Coimbatore",
    city: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private — Deemed University",
    established: 1994,
    students: 9800,
    faculty: 540,
    facultyRatio: "1:18",
    accreditation: ["NAAC A++", "NBA"],
    cost: 1180000,
    medianSalary: 920000,
    placementRate: 78,
    higherStudies: 17,
    transparency: 71,
    outcomeScore: 76,
    roiRating: "AA",
    research: 68,
    diversity: 77,
    sources: ["NIRF 2024", "Institution Annual Report"],
    advertised: { highest: 7200000, average: 1180000, placementShown: 89 },
    filed: { median: 920000, average: 860000, placementReported: 78, higherStudiesReported: 17 },
  },
  {
    id: "tce-madurai",
    name: "Thiagarajar College of Engineering",
    short: "TCE Madurai",
    city: "Madurai",
    state: "Tamil Nadu",
    type: "Private — Autonomous",
    established: 1957,
    students: 4800,
    faculty: 280,
    facultyRatio: "1:17",
    accreditation: ["NAAC A++", "NBA"],
    cost: 520000,
    medianSalary: 720000,
    placementRate: 76,
    higherStudies: 22,
    transparency: 74,
    outcomeScore: 73,
    roiRating: "AAA",
    research: 64,
    diversity: 72,
    sources: ["NIRF 2024", "AICTE Disclosure 2024"],
    advertised: { highest: 3800000, average: 880000, placementShown: 86 },
    filed: { median: 720000, average: 680000, placementReported: 76, higherStudiesReported: 22 },
  },
  {
    id: "iit-bombay",
    name: "Indian Institute of Technology Bombay",
    short: "IIT Bombay",
    city: "Mumbai",
    state: "Maharashtra",
    type: "Public — Institute of National Importance",
    established: 1958,
    students: 11200,
    faculty: 712,
    facultyRatio: "1:16",
    accreditation: ["NAAC A++", "NBA", "MoE INI"],
    cost: 880000,
    medianSalary: 2160000,
    placementRate: 92,
    higherStudies: 31,
    transparency: 92,
    outcomeScore: 94,
    roiRating: "AAA",
    research: 96,
    diversity: 78,
    sources: ["NIRF 2024", "AICTE Disclosure 2024", "Institution Annual Report"],
    advertised: { highest: 21800000, average: 2380000, placementShown: 96 },
    filed: { median: 2160000, average: 1980000, placementReported: 92, higherStudiesReported: 31 },
  },
  {
    id: "iit-delhi",
    name: "Indian Institute of Technology Delhi",
    short: "IIT Delhi",
    city: "New Delhi",
    state: "Delhi",
    type: "Public — Institute of National Importance",
    established: 1961,
    students: 10800,
    faculty: 698,
    facultyRatio: "1:15",
    accreditation: ["NAAC A++", "NBA", "MoE INI"],
    cost: 860000,
    medianSalary: 2050000,
    placementRate: 91,
    higherStudies: 28,
    transparency: 90,
    outcomeScore: 93,
    roiRating: "AAA",
    research: 94,
    diversity: 74,
    sources: ["NIRF 2024", "AICTE Disclosure 2024"],
    advertised: { highest: 20100000, average: 2240000, placementShown: 95 },
    filed: { median: 2050000, average: 1870000, placementReported: 91, higherStudiesReported: 28 },
  },
  {
    id: "iit-madras",
    name: "Indian Institute of Technology Madras",
    short: "IIT Madras",
    city: "Chennai",
    state: "Tamil Nadu",
    type: "Public — Institute of National Importance",
    established: 1959,
    students: 10100,
    faculty: 680,
    facultyRatio: "1:15",
    accreditation: ["NAAC A++", "NBA", "MoE INI"],
    cost: 840000,
    medianSalary: 2020000,
    placementRate: 90,
    higherStudies: 33,
    transparency: 94,
    outcomeScore: 95,
    roiRating: "AAA",
    research: 97,
    diversity: 81,
    sources: ["NIRF 2024", "AICTE Disclosure 2024", "Institution Annual Report"],
    advertised: { highest: 19600000, average: 2210000, placementShown: 94 },
    filed: { median: 2020000, average: 1840000, placementReported: 90, higherStudiesReported: 33 },
  },
  {
    id: "iim-ahmedabad",
    name: "Indian Institute of Management Ahmedabad",
    short: "IIM Ahmedabad",
    city: "Ahmedabad",
    state: "Gujarat",
    type: "Public — Institute of National Importance",
    established: 1961,
    students: 1240,
    faculty: 108,
    facultyRatio: "1:11",
    accreditation: ["NAAC A++", "AACSB", "EQUIS"],
    cost: 2750000,
    medianSalary: 3450000,
    placementRate: 100,
    higherStudies: 4,
    transparency: 88,
    outcomeScore: 96,
    roiRating: "AAA",
    research: 88,
    diversity: 62,
    sources: ["NIRF 2024", "Institution Audited Placement Report"],
    advertised: { highest: 13200000, average: 3520000, placementShown: 100 },
    filed: { median: 3450000, average: 3380000, placementReported: 100, higherStudiesReported: 4 },
  },
  {
    id: "iim-bangalore",
    name: "Indian Institute of Management Bangalore",
    short: "IIM Bangalore",
    city: "Bengaluru",
    state: "Karnataka",
    type: "Public — Institute of National Importance",
    established: 1973,
    students: 1180,
    faculty: 102,
    facultyRatio: "1:11",
    accreditation: ["NAAC A++", "AACSB", "EQUIS"],
    cost: 2620000,
    medianSalary: 3280000,
    placementRate: 99,
    higherStudies: 3,
    transparency: 86,
    outcomeScore: 94,
    roiRating: "AAA",
    research: 85,
    diversity: 68,
    sources: ["NIRF 2024", "Institution Audited Placement Report"],
    advertised: { highest: 11400000, average: 3360000, placementShown: 100 },
    filed: { median: 3280000, average: 3210000, placementReported: 99, higherStudiesReported: 3 },
  },
  {
    id: "bits-pilani",
    name: "Birla Institute of Technology and Science, Pilani",
    short: "BITS Pilani",
    city: "Pilani",
    state: "Rajasthan",
    type: "Private — Deemed University",
    established: 1964,
    students: 18400,
    faculty: 612,
    facultyRatio: "1:30",
    accreditation: ["NAAC A", "UGC Autonomous"],
    cost: 2080000,
    medianSalary: 1820000,
    placementRate: 88,
    higherStudies: 22,
    transparency: 81,
    outcomeScore: 87,
    roiRating: "AA",
    research: 78,
    diversity: 71,
    sources: ["NIRF 2024", "Institution Annual Report"],
    advertised: { highest: 17500000, average: 2050000, placementShown: 95 },
    filed: { median: 1820000, average: 1690000, placementReported: 88, higherStudiesReported: 22 },
  },
  {
    id: "nit-trichy",
    name: "National Institute of Technology, Tiruchirappalli",
    short: "NIT Trichy",
    city: "Tiruchirappalli",
    state: "Tamil Nadu",
    type: "Public — Institute of National Importance",
    established: 1964,
    students: 9800,
    faculty: 412,
    facultyRatio: "1:24",
    accreditation: ["NAAC A++", "NBA"],
    cost: 720000,
    medianSalary: 1480000,
    placementRate: 86,
    higherStudies: 24,
    transparency: 87,
    outcomeScore: 85,
    roiRating: "AAA",
    research: 76,
    diversity: 73,
    sources: ["NIRF 2024", "AICTE Disclosure 2024"],
    advertised: { highest: 8400000, average: 1620000, placementShown: 91 },
    filed: { median: 1480000, average: 1390000, placementReported: 86, higherStudiesReported: 24 },
  },
  {
    id: "vit-vellore",
    name: "Vellore Institute of Technology",
    short: "VIT Vellore",
    city: "Vellore",
    state: "Tamil Nadu",
    type: "Private — Deemed University",
    established: 1984,
    students: 38600,
    faculty: 1840,
    facultyRatio: "1:21",
    accreditation: ["NAAC A++", "ABET"],
    cost: 1580000,
    medianSalary: 940000,
    placementRate: 79,
    higherStudies: 14,
    transparency: 64,
    outcomeScore: 71,
    roiRating: "A",
    research: 62,
    diversity: 82,
    sources: ["NIRF 2024", "Institution Annual Report"],
    advertised: { highest: 11800000, average: 1320000, placementShown: 92 },
    filed: { median: 940000, average: 880000, placementReported: 79, higherStudiesReported: 14 },
  },
  {
    id: "manipal-mit",
    name: "Manipal Institute of Technology",
    short: "Manipal MIT",
    city: "Manipal",
    state: "Karnataka",
    type: "Private — Deemed University",
    established: 1957,
    students: 12400,
    faculty: 668,
    facultyRatio: "1:18",
    accreditation: ["NAAC A+", "NBA"],
    cost: 1820000,
    medianSalary: 880000,
    placementRate: 76,
    higherStudies: 18,
    transparency: 68,
    outcomeScore: 73,
    roiRating: "A",
    research: 65,
    diversity: 79,
    sources: ["NIRF 2024", "AICTE Disclosure 2024"],
    advertised: { highest: 6200000, average: 1180000, placementShown: 88 },
    filed: { median: 880000, average: 820000, placementReported: 76, higherStudiesReported: 18 },
  },
  {
    id: "srm-chennai",
    name: "SRM Institute of Science and Technology",
    short: "SRM Chennai",
    city: "Chennai",
    state: "Tamil Nadu",
    type: "Private — Deemed University",
    established: 1985,
    students: 52000,
    faculty: 2110,
    facultyRatio: "1:25",
    accreditation: ["NAAC A++"],
    cost: 1420000,
    medianSalary: 720000,
    placementRate: 72,
    higherStudies: 11,
    transparency: 58,
    outcomeScore: 64,
    roiRating: "BBB",
    research: 54,
    diversity: 84,
    sources: ["NIRF 2024", "Institution Annual Report"],
    advertised: { highest: 5400000, average: 990000, placementShown: 89 },
    filed: { median: 720000, average: 690000, placementReported: 72, higherStudiesReported: 11 },
  },
  {
    id: "du-delhi",
    name: "University of Delhi",
    short: "Delhi University",
    city: "New Delhi",
    state: "Delhi",
    type: "Public — Central University",
    established: 1922,
    students: 132000,
    faculty: 5800,
    facultyRatio: "1:23",
    accreditation: ["NAAC A+", "UGC"],
    cost: 240000,
    medianSalary: 680000,
    placementRate: 64,
    higherStudies: 38,
    transparency: 76,
    outcomeScore: 78,
    roiRating: "AAA",
    research: 82,
    diversity: 91,
    sources: ["NIRF 2024", "UGC Public Report"],
    advertised: { highest: 4800000, average: 820000, placementShown: 78 },
    filed: { median: 680000, average: 640000, placementReported: 64, higherStudiesReported: 38 },
  },
  {
    id: "jnu",
    name: "Jawaharlal Nehru University",
    short: "JNU",
    city: "New Delhi",
    state: "Delhi",
    type: "Public — Central University",
    established: 1969,
    students: 8400,
    faculty: 612,
    facultyRatio: "1:14",
    accreditation: ["NAAC A++"],
    cost: 180000,
    medianSalary: 620000,
    placementRate: 52,
    higherStudies: 54,
    transparency: 82,
    outcomeScore: 76,
    roiRating: "AAA",
    research: 89,
    diversity: 93,
    sources: ["NIRF 2024", "UGC Public Report"],
    advertised: { highest: 2400000, average: 680000, placementShown: 62 },
    filed: { median: 620000, average: 600000, placementReported: 52, higherStudiesReported: 54 },
  },
  {
    id: "anna-univ",
    name: "Anna University",
    short: "Anna University",
    city: "Chennai",
    state: "Tamil Nadu",
    type: "Public — State University",
    established: 1978,
    students: 27800,
    faculty: 1340,
    facultyRatio: "1:21",
    accreditation: ["NAAC A+", "NBA"],
    cost: 380000,
    medianSalary: 720000,
    placementRate: 71,
    higherStudies: 20,
    transparency: 78,
    outcomeScore: 75,
    roiRating: "AAA",
    research: 74,
    diversity: 80,
    sources: ["NIRF 2024", "AICTE Disclosure 2024"],
    advertised: { highest: 3800000, average: 880000, placementShown: 81 },
    filed: { median: 720000, average: 680000, placementReported: 71, higherStudiesReported: 20 },
  },
  {
    id: "jadavpur",
    name: "Jadavpur University",
    short: "Jadavpur University",
    city: "Kolkata",
    state: "West Bengal",
    type: "Public — State University",
    established: 1955,
    students: 11200,
    faculty: 612,
    facultyRatio: "1:18",
    accreditation: ["NAAC A+"],
    cost: 220000,
    medianSalary: 880000,
    placementRate: 78,
    higherStudies: 26,
    transparency: 80,
    outcomeScore: 82,
    roiRating: "AAA",
    research: 81,
    diversity: 76,
    sources: ["NIRF 2024", "UGC Public Report"],
    advertised: { highest: 5400000, average: 980000, placementShown: 84 },
    filed: { median: 880000, average: 820000, placementReported: 78, higherStudiesReported: 26 },
  },
  {
    id: "amity",
    name: "Amity University Noida",
    short: "Amity Noida",
    city: "Noida",
    state: "Uttar Pradesh",
    type: "Private — Deemed University",
    established: 2005,
    students: 41200,
    faculty: 1860,
    facultyRatio: "1:22",
    accreditation: ["NAAC A+"],
    cost: 1620000,
    medianSalary: 620000,
    placementRate: 68,
    higherStudies: 12,
    transparency: 54,
    outcomeScore: 58,
    roiRating: "BB",
    research: 48,
    diversity: 78,
    sources: ["NIRF 2024", "Institution Annual Report"],
    advertised: { highest: 4800000, average: 940000, placementShown: 89 },
    filed: { median: 620000, average: 580000, placementReported: 68, higherStudiesReported: 12 },
  },
  {
    id: "lpu",
    name: "Lovely Professional University",
    short: "LPU",
    city: "Phagwara",
    state: "Punjab",
    type: "Private — State University",
    established: 2005,
    students: 35800,
    faculty: 1620,
    facultyRatio: "1:22",
    accreditation: ["NAAC A+"],
    cost: 1280000,
    medianSalary: 560000,
    placementRate: 66,
    higherStudies: 10,
    transparency: 52,
    outcomeScore: 55,
    roiRating: "BB",
    research: 44,
    diversity: 86,
    sources: ["NIRF 2024", "Institution Annual Report"],
    advertised: { highest: 5200000, average: 880000, placementShown: 91 },
    filed: { median: 560000, average: 520000, placementReported: 66, higherStudiesReported: 10 },
  },
];

// Course offerings per college (used by the matching feature).
export const COURSE_MAP = {
  "iit-bombay": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "Biotechnology"],
  "iit-delhi": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil"],
  "iit-madras": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "Biotechnology"],
  "iim-ahmedabad": ["BBA"],
  "iim-bangalore": ["BBA"],
  "bits-pilani": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "Biotechnology"],
  "nit-trichy": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil"],
  "vit-vellore": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "Biotechnology", "BCA", "BBA"],
  "manipal-mit": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "Biotechnology", "BCA"],
  "srm-chennai": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "Biotechnology", "BCA", "BBA"],
  "du-delhi": ["BCA", "BBA"],
  "jnu": ["Biotechnology"],
  "anna-univ": ["Computer Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "Biotechnology"],
  "jadavpur": ["Computer Science", "ECE", "EEE", "Mechanical", "Civil"],
  "amity": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "BCA", "BBA", "Biotechnology"],
  "lpu": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "BCA", "BBA", "Biotechnology"],
  "psg-coimbatore": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "Biotechnology"],
  "amrita-coimbatore": ["Computer Science", "AI & Data Science", "IT", "ECE", "EEE", "Mechanical", "Civil", "BCA", "Biotechnology"],
  "tce-madurai": ["Computer Science", "IT", "ECE", "EEE", "Mechanical", "Civil"],
};

// Attach courses to each college object at module load.
colleges.forEach((c) => { c.courses = COURSE_MAP[c.id] || []; });

export const getCollege = (id) => colleges.find((c) => c.id === id);

export const formatINR = (n) => {
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  return `₹${n.toLocaleString("en-IN")}`;
};

export const transparencyBand = (t) => {
  if (t >= 80) return { label: "Very Open", color: "#059669", bg: "rgba(5,150,105,0.08)" };
  if (t >= 65) return { label: "Somewhat Open", color: "#4682B4", bg: "rgba(70,130,180,0.08)" };
  return { label: "Less Open", color: "#D97706", bg: "rgba(217,119,6,0.08)" };
};

export const variance = (a, b) => {
  if (!a || !b) return 0;
  return Math.abs((a - b) / a) * 100;
};

export const varianceBand = (v) => {
  if (v < 15) return { label: "Small Gap", color: "#059669", bg: "rgba(5,150,105,0.08)" };
  if (v < 40) return { label: "Some Gap", color: "#4682B4", bg: "rgba(70,130,180,0.08)" };
  return { label: "Big Gap", color: "#D97706", bg: "rgba(217,119,6,0.08)" };
};
